import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MovFirmaParticipanteM } from '../model/det-participante-bean';
import { Response_dml_bean } from '../model/response-dml';

@Injectable({
  providedIn: 'root'
})
export class MaeProcesoService {
  baseURL = environment.urlBase;
  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;

  constructor(private httpclient:HttpClient) {}

  generar(P_C_PARTICIPANTE: string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/generar';

    let params = new HttpParams()
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<Response_dml_bean>(url,  {headers:headers, params: params});

  }
  generartodos(P_C_CONSTANCIA: string,P_C_TIPO:string,P_C_ESTADO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/generartodo';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_TIPO', P_C_TIPO)
    .set('P_C_ESTADO', P_C_ESTADO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<Response_dml_bean>(url,  {headers:headers, params: params});

  }
  recuperarfirmado(P_C_CONSTANCIA:string,P_C_PARTICIPANTE: string,P_C_USUARIO:string,NOMBRE_ARCHIVO:string): Observable<MovFirmaParticipanteM[]> {

    var url  : string;
    url = this.baseURL + 'proceso/api/recuperarfirmado';

    let params = new HttpParams()
    .set('idc', P_C_CONSTANCIA)
    .set('idp', P_C_PARTICIPANTE)
    .set('iduser', P_C_USUARIO)
    .set('nombre_archivo', NOMBRE_ARCHIVO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<MovFirmaParticipanteM[]>(url,  {headers:headers, params: params});

  }

  confirmarfirma(P_C_FIRMA: string,RUTA_ARCHIVO:string,NRO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/confirmarfirma';

    let params = new HttpParams()
    .set('idp', P_C_FIRMA)
    .set('ruta', RUTA_ARCHIVO)
    .set('nro', NRO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,  {headers:headers, params: params});

  }
  /*
  confirmarfirma(P_C_CONSTANCIA:string,P_C_PARTICIPANTE: string,P_C_USUARIO:string,NOMBRE_ARCHIVO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/confirmarfirma';

    let params = new HttpParams()
    .set('idc', P_C_CONSTANCIA)
    .set('idp', P_C_PARTICIPANTE)
    .set('iduser', P_C_USUARIO)
    .set('nombre_archivo', NOMBRE_ARCHIVO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,  {headers:headers, params: params});

  }*/

  enviarfirma(formData:FormData,P_C_CONSTANCIA:string,P_C_PARTICIPANTE:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/evniarafirmar';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE);
    //formData.append(id,'22');

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.post<Response_dml_bean>(url,formData,{headers:headers, params: params});

  }
  juntarwords(P_C_CONSTANCIA : string): Observable<Blob> {

    var url  : string;
    url = this.baseURL + 'proceso/api/juntarwords';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get(url, {headers:headers, params: params,responseType: 'blob'});
  }
  bajarparajuntarenZip(P_C_CONSTANCIA : string,P_C_USUARIO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/pregenerarzip';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_USUARIO', P_C_USUARIO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url, {headers:headers, params: params});
  }

  juntarenZip(P_C_CONSTANCIA : string,P_C_USUARIO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/generarzip';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_USUARIO', P_C_USUARIO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url, {headers:headers, params: params});

  }
  observar(P_C_PARTICIPANTE: string, P_C_FIRMA:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/observar';

    let params = new HttpParams()
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE)
    .set('P_C_FIRMA', P_C_FIRMA);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,  {headers:headers, params: params});

  }
  observartodos(P_C_CONSTANCIA:string,P_C_USUARIO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/observartodo';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_USUARIO', P_C_USUARIO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,  {headers:headers, params: params});

  }
  enviarcorreo(P_C_CONSTANCIA:string,P_C_PARTICIPANTE:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/enviarcorreo';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE);
    //formData.append(id,'22');

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,{headers:headers, params: params});

  }
  enviarcorreoprueba(P_C_CONSTANCIA:string,P_C_USUARIO:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'proceso/api/enviarcorreotest';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_USUARIO', P_C_USUARIO);
    //formData.append(id,'22');

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,{headers:headers, params: params});

  }
}
